import React, { useContext } from "react"
import { Link, useLocation } from "react-router-dom"

import { Calendar } from "./icons/Calendar"
import { Button } from "../../components/common/button/Button"
import { Seperator } from "../../components/common/seperator/seperator"
import VehicleInfoContainer from "../../components/common/VehicleInfoContainer/VehicleInfoContainer"
import { Timer } from "./icons/Timer"
import { Location } from "./icons/Location"
import { AppointmentBookedLoader } from "../Loaders/AppointmentBookedLoader"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { ItemsToBring } from "./ItemToBring"
import { items } from "./items"
import { BlueAlertIcon } from "./BlueAlertIcon"
import { checkPath } from '../../utils/validation-utils'

const AppointmentConfirmation: React.FC = () => {
  const { search } = useLocation()
  const {
    state: {
      bookingStatus,
      bookingDate,
      bookingTime,
      dealershipUrl,
      appointmentDetails: { dealership },
    },
    actions: { resetState }
  } = useContext(AppContext) as AppContextInterface

  if (!bookingStatus) {
    return <AppointmentBookedLoader />
  }

  return (
    <div className="appointment-confirmation-container">
      <VehicleInfoContainer />
      <div className="heading-container">
        <h2 className="confirmation-details-heading">
          Your appointment is booked!
        </h2>
      </div>
      <div className="inner-container">
        <p className="confirmation-details-paragraph">
          Thank you for choosing us to sell your vehicle with us.
        </p>
        <Seperator />
        <div className="button-container">
          <div className="location-container">
            <Location />
            <p className="location-paragraph">{dealership}</p>
          </div>
          <div className="date-container">
            <Calendar />
            <p className="date-paragraph">{bookingDate}</p>
          </div>
          <div className="time-container">
            <Timer />
            <p className="time-paragraph">{bookingTime}</p>
          </div>
          <Seperator />
          <div className="details-container">
            <h2 className="details-to-bring">Remember to bring...</h2>
            <h3 className="details-paragraph">
              Please ensure to remember to bring the following to your
              appointment:
            </h3>
            <ItemsToBring items={items} />
            <div className="faq-paragraph">
              <p>
                If you are selling a vehicle on behalf of a deceased person's
                estate we will require the following additional documentation.
                Please also see our{" "}
                <a
                  className="underlined"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.lookers.co.uk/terms-and-conditions/click-and-sell-faqs/bereavement"
                >
                  FAQs
                </a>
                .
              </p>
            </div>
            <div className="alert-container">
              <BlueAlertIcon />
              <p className="item-text">Grant of probate</p>
            </div>
            <div className="alert-container">
              <BlueAlertIcon />
              <p className="item-text">Death certificate</p>
            </div>
          </div>
          {dealershipUrl ? (
            <>
              <Seperator />
              <h3 className="contact-dealership-text">
                Need help? Contact your dealership
              </h3>
              <a
                className="no-underline"
                target="_blank"
                rel="noopener noreferrer"
                href={dealershipUrl}
              >
                <Button type="button" variant="white" id="contact-dealership">
                  CONTACT DEALERSHIP
                </Button>
              </a>
            </>
          ) : null}
          <Seperator />
          {/* </Link> */}
          <Link className="text-link" to={checkPath(search)}>
            <Button type="button" onClick={() => resetState()} variant="blue" id="value-another-vehicle">
              VALUE ANOTHER VEHICLE
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AppointmentConfirmation
